/**
 * Rewrites the Akamai pictures host in the `imageUrl` preference to the CloudFront
 * pictures-proxy alias, so CloudFront caches and offloads the repeat traffic.
 *
 * Mirrors `UrlUtils.rewritePicturesHost` in cms-core. The widget needs its own copy
 * because the Composer image-picker value reaches it as a preference and never passes
 * through cms-core's rewrite.
 */

/**
 * Anchored to the start of the URL, so only the authority is a candidate --
 * never a path segment or a query value.
 *
 * Deliberately narrower than `isDealerImage` in `./images`: that one is a tolerance
 * predicate for resize gating (it already matches the CloudFront aliases, the
 * `images`/`static` hosts and `/static/` paths), this one is an emission rewrite.
 * Do not consolidate them.
 */
const PICTURES_HOST =
	/^((?:https?:)?\/\/)pictures(?:-np)?\.dealer\.com(?=[/:?#]|$)/;

const isBlank = (value) => !value || !String(value).trim();

/**
 * Swaps the pictures host in a single URL. Returns the input unchanged (by
 * identity) when there is no URL or no CloudFront host configured.
 * @param {string} url - A URL string value
 * @param {string} cloudfrontHost - The CloudFront alias from the feature flag
 */
export const rewritePicturesHost = (url, cloudfrontHost) => {
	if (isBlank(url) || isBlank(cloudfrontHost)) {
		return url;
	}

	// A replacer function, not a `$1${host}` template: a string replacement
	// would interpret $1/$&/$$ appearing in the flag value.
	return url.replace(PICTURES_HOST, (match, proto) => proto + cloudfrontHost);
};
